import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  addUomPrice,
  editItem,
  fetchDataType,
  fetchDetailPrices,
  fetchId,
  fetchIdNoloading,
  selectDataDetail,
  selectDataType,
  selectId,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./pricelistSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  showDialog,
  defaultDate,
  setOptionsMaster,
  paramsMasterAll,
  useForceUpdate,
  formatCurrency,
  formatterStatus,
  checkEmptyFields,
  getValueOptions,
  getValueOptionsMultiple,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { fetchParam, selectDataParam } from "../param/paramSlice";
import moment from "moment";
import InputNumber from "../../utility/InputNumber";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { fetchTemplate, selectLoadingTemplate } from "../product/productSlice";
import SVG from "react-inlinesvg";
import { NavLink } from "react-router-dom";
import { fetchUom, selectUom } from "../uom/uomSlice";
import paginationFactory from "react-bootstrap-table2-paginator";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import MultiSelectAll from "../../utility/MultiSelectAll";

export const PricelistCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const { id } = useParams();
  const dataParam = useSelector(selectDataParam);
  const dataType = useSelector(selectDataType);
  const dataDetail = useSelector(selectDataDetail);
  const { SearchBar } = Search;
  const forceUpdate = useForceUpdate();
  const loading2 = useSelector(selectLoadingTemplate);
  const ref = useRef();
  const dataUom = useSelector(selectUom);
  const dataBranch = useSelector(selectBranch);

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [refPrice, setRefPrice] = useState("");
  const [ratio, setRatio] = useState("");
  const [date, setDate] = useState("");
  const [tableData, setTableData] = useState([]);
  const [optionsCode, setOptionCode] = useState([]);
  const [optionsBranch, setOptionBranch] = useState([]);
  const [optionsRef, setOptionRef] = useState([]);
  const [optionsUom, setOptionUom] = useState([]);

  const [uom, setUom] = useState("");
  const [price, setPrice] = useState("");
  const [product, setProduct] = useState(null);
  const [branch, setBranch] = useState([]);

  const handleBranchChange = (selectedOptions) => {
    if (selectedOptions) {
      setBranch(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setBranch([]);
    }
  };

  const paramsId = {
    pricelist_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
        await dispatch(
          fetchDetailPrices({ ...paramsMasterAll, pricelist_id: id })
        );
      }
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "CUSTOMER_GROUP",
          is_active: true,
        })
      );
      await dispatch(fetchBranch({ ...paramsMasterAll }));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setCode(dataId?.customer_group);
      setName(dataId?.pricelist_name);
      setRefPrice(dataId?.ref_pricelist_id);
      setBranch(
        dataId?.branch_code
          ? dataId.branch_code.split(",").map((code) => code.trim())
          : []
      );

      setDate(moment(dataId?.effective_date).format("YYYY-MM-DD"));
      setRatio(parseFloat(dataId?.ratio));
    }
  }, [dataId]);
  useEffect(() => {
    if (dataDetail) {
      const initData = dataDetail.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });
      setTableData(initData);
    }
  }, [dataDetail]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionCode, "param_code", "param_value");
    }
  }, [dataParam]);

  useEffect(() => {
    if (dataType.length > 0) {
      setOptionsMaster(
        dataType,
        setOptionRef,
        "pricelist_id",
        "pricelist_name"
      );
    }
  }, [dataType]);

  useEffect(() => {
    if (dataUom.length > 0) {
      setOptionsMaster(dataUom, setOptionUom, "uom_id", "uom_code");
    }
  }, [dataUom]);
  useEffect(() => {
    if (dataBranch && dataBranch.length > 0) {
      setOptionsMaster(
        dataBranch,
        setOptionBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [dataBranch]);

  const handleSave = async () => {
    const fields = [
      { value: code, message: "input Customer Grup", valid: true },
      { value: ratio, message: "input Ratio", valid: true },
      { value: date, message: "input Effective Date", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    if (refPrice === "" && parseInt(ratio) !== 1) {
      return showDialog("If there is no ref price then the Ratio must be 1");
    }

    console.log(parseInt(ratio), "asd");
    console.log(refPrice, "refPrice");
    const params = {
      pricelist_id: id,
      customer_group: code,
      pricelist_name: name,
      ratio: ratio,
      ref_pricelist_id: refPrice,
      effective_date: date,
      pricelist_details: tableData,
      branch_code: branch,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
        await dispatch(
          fetchDetailPrices({ ...paramsMasterAll, pricelist_id: id })
        );
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleChangeCode = (e) => {
    if (e === undefined) {
      e = undefined;
      setCode("");
      setRefPrice("");
    } else {
      setCode(e.value);
      dispatch(fetchDataType({ ...paramsMasterAll, customer_group: e.value }));
    }
  };

  const handleChangeReff = (e) => {
    if (e === null) {
      e = undefined;
      setRefPrice("");
    } else {
      setRefPrice(e.value);
    }
  };

  const handleQty = (e, row, rowIndex, formatExtraData) => {
    // Jika nilai price tidak valid (null, undefined, NaN, atau bukan angka), set ke 0
    if (
      isNaN(row.price) ||
      row.price === null ||
      row.price === undefined ||
      row.price === ""
    ) {
      row.price = 0;
      forceUpdate();
      return;
    }

    // Jika nilai price valid tetapi kurang dari 0, juga set ke 0
    if (Number(row.price) < 0) {
      row.price = 0;
      forceUpdate();
      return;
    }

    // Pastikan price disimpan sebagai integer
    row.price = parseInt(row.price, 10);
    forceUpdate();
  };

  const inputQtyFormmater = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        className="input-qty"
        step="1"
        min="0"
        value={isNaN(parseInt(row.price)) ? "" : parseInt(row.price)}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };

  const actionFormatter = (e, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="pricelists-edit-tooltip">Add Uom</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              dispatch(
                fetchUom({ ...paramsMasterAll, product_id: row?.product_id })
              );
              setShowUom(true);
              setProduct(row);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { maxWidth: "60px" },
      editable: false,
    },

    {
      text: "product Code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      editable: false,
    },
    {
      text: "product name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      editable: false,
    },
    {
      text: "uom",
      dataField: "uom_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      editable: false,
    },
    {
      text: "price",
      dataField: "price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { maxWidth: "100px" },
      // editable: false,
      formatExtraData: tableData,
      formatter: inputQtyFormmater,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      hidden: dataId?.ref_pricelist_id === null ? false : true,
    },
    {
      text: "base price",
      dataField: "base_price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { maxWidth: "100px" },
      editable: false,
      formatter: formatCurrency,
      align: "right",
      hidden: dataId?.ref_pricelist_id === null ? true : false,
    },
    {
      text: "price",
      dataField: "price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { maxWidth: "100px" },
      editable: false,
      formatter: formatCurrency,
      align: "right",
      hidden: dataId?.ref_pricelist_id === null ? true : false,
    },
    {
      text: "Action",
      dataField: "action",
      align: "center",
      formatter: actionFormatter,
      editable: false,
    },
  ];

  // upload
  const [showUpload, setShowUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [tableUpload, setTableUpload] = useState([]);

  const handleShowUpload = (data) => {
    setShowUpload(true);
  };

  const handleCloseUpload = () => {
    setTableUpload([]);
    setShowUpload(false);
  };

  const handleUpload = async () => {
    const params = tableUpload
      .filter((entry) => entry.status_validation === "Success")
      .map((item) => {
        return {
          ...item,
          pricelist_id: id,
        };
      });

    if (params.length === 0) {
      return showDialog("Please upload data first");
    }

    try {
      const response = await dispatch(uploadItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileUpload(selectedFile);
    validateFile(selectedFile);
  };

  const validateFile = async (file) => {
    if (file) {
      try {
        const response = await dispatch(uploadValidate(file));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const initData = response.payload.data.data.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
          setTableUpload(initData);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error.message);
      }
    } else {
      console.log("No file uploaded");
    }
  };

  const columnsUpload = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "group",
      dataField: "customer_group",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "uom",
      dataField: "uom_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "price",
      dataField: "price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "status",
      dataField: "status_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "message",
      dataField: "message_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const handleDownload = async () => {
    const params = {
      file_type: "PRICELIST",
      pricelist_id: id,
    };
    try {
      const response = await dispatch(fetchTemplate(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "PRICELIST.xlsx";
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  // UOMS
  const [showUom, setShowUom] = useState(false);

  const handleShowUom = (data) => {
    setShowUom(true);
  };

  const handleCloseUom = () => {
    setShowUom(false);
    setProduct(null);
    setUom("");
    setPrice("");
  };

  const handleChangeUom = createChangeHandler(setUom);

  const handleSaveUom = async () => {
    const params = {
      pricelist_id: id,
      product_id: product?.product_id,
      uom_id: uom,
      price: price,
    };

    try {
      const response = await dispatch(addUomPrice(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await handleCloseUom();
        await showSuccessDialog(response.payload.message);
        await dispatch(
          fetchDetailPrices({ ...paramsMasterAll, pricelist_id: id })
        );
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  return loading || loading2 ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create  Price List" : "Edit Price List"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            {dataId !== undefined && dataId?.ref_pricelist_id === null && (
              <Button
                className="btn btn-warning mr-3"
                onClick={handleShowUpload}
              >
                Upload
              </Button>
            )}

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Customer Group<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsCode}
                      value={getValueStatus(code, optionsCode)}
                      placeholder="Select ..."
                      onChange={handleChangeCode}
                      isDisabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Pricelist Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                      disabled={
                        dataId?.ref_pricelist_id === null ? true : false
                      }
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Branch</b>
                  </Form.Label>
                  <Col sm={6}>
                    <MultiSelectAll
                      options={optionsBranch}
                      value={getValueOptionsMultiple(branch, optionsBranch)}
                      onChange={handleBranchChange}
                      placeholder="Select Branch..."
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                {id === undefined && (
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Ref Pricelist</b>
                    </Form.Label>
                    <Col sm={6}>
                      <Select
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        options={optionsRef}
                        value={getValueStatus(refPrice, optionsRef)}
                        placeholder="Select ..."
                        onChange={handleChangeReff}
                        isClearable={true}
                      />
                    </Col>
                  </Form.Group>
                )}
                {id !== undefined && (
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Ref Pricelist</b>{" "}
                    </Form.Label>
                    <Col sm={6}>
                      <Form.Control
                        type="text"
                        value={dataId?.ref_pricelist_name}
                        disabled={id !== undefined ? true : false}
                      />
                    </Col>
                    {dataId?.ref_pricelist_id !== null && (
                      <Col>
                        <a
                          className="menu-link"
                          href={`/master/pricelist/edit/${dataId?.ref_pricelist_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="btn btn-icon btn-light btn-hover-danger btn-sm mt-1">
                            <span className="svg-icon svg-icon-md svg-icon-secondary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Share.svg"
                                )}
                              />
                            </span>
                          </div>
                        </a>
                      </Col>
                    )}
                  </Form.Group>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Ratio<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="number"
                      onChange={(e) => {
                        const value = parseFloat(e.target.value);
                        if (value >= 0 || e.target.value === "") {
                          setRatio(e.target.value);
                        }
                      }}
                      value={ratio}
                      disabled={
                        dataId?.ref_pricelist_id === null ? true : false
                      }
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Effective Date<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="date"
                      onChange={(e) => setDate(e.target.value)}
                      value={date}
                      min={defaultDate}
                      disabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
          {id !== undefined && (
            <ToolkitProvider
              keyField="no"
              data={tableData}
              columns={columns}
              search
            >
              {(props) => (
                <div>
                  <Row>
                    <Col>
                      <div className="float-right">
                        <SearchBar
                          {...props.searchProps}
                          placeholder="Search .."
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-container ">
                    <BootstrapTable
                      // wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center"
                      bootstrap4
                      bordered={true}
                      {...props.baseProps}
                      cellEdit={cellEditFactory({
                        mode: "click",
                        blurToSave: true,
                      })}
                      pagination={paginationFactory({
                        sizePerPage: 50,
                        showTotal: true, // Menampilkan total data
                        withFirstAndLast: true,
                      })}
                    />
                  </div>
                </div>
              )}
            </ToolkitProvider>
          )}
        </CardBody>
      </Card>

      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Price List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    File <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input "
                    onChange={handleFileChange}
                    custom
                    accept=".xlsx"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Button variant="warning" onClick={() => handleDownload()}>
                Download Template
              </Button>
            </Col>
          </Form.Group>

          {tableUpload.length > 0 && (
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-5"
              bootstrap4
              keyField="no"
              data={tableUpload}
              columns={columnsUpload}
              hover
              striped
            ></BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUpload()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleUpload}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showUom}
        onHide={handleCloseUom}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Uom</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Product Code</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={product?.product_code}
                    disabled
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Product Name</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={product?.product_name}
                    disabled
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    UOM <b className="color-red">*</b>{" "}
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsUom}
                    value={getValueStatus(uom, optionsUom)}
                    placeholder="Select ..."
                    onChange={handleChangeUom}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Price</b>
                </Form.Label>
                <Col sm={6}>
                  <CurrencyInput
                    id="input-example"
                    className="form-control text-right"
                    name=""
                    placeholder="Price"
                    decimalsLimit={2}
                    onValueChange={(value) => {
                      setPrice(value > 0 ? value : 0);
                    }}
                    groupSeparator=","
                    decimalSeparator="."
                    value={price}
                  />{" "}
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUom()}>
            Close
          </Button>
          <Button variant="danger" onClick={() => handleSaveUom()}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>
    </>
  );
};
